<template>
  <input class="field-input__inner form__input"
         ref="phone"
         :placeholder="placeholder"
         :required="required"
         type="phone"
         inputmode="tel"
         v-model="onEnteredPhone"
         @input="onChangePhone"
         @blur="onBlurPhone"
         @keydown="keyDown"
         @keyup="keyup"
         @focus="$emit('focus')"
  >
</template>
<script>
/* global $ */
import InputMask from 'inputmask';

export default {
  name: 'InputPhone',
  props: {
    mask: {
      type: String,
      default: '+7(999)999-99-99',
    },
    showMaskOnFocus: {
      type: Boolean,
      default: true,
    },
    showMaskOnHover: {
      type: Boolean,
      default: false,
    },
    dynamicMask: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Ваш номер телефона*',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      onEnteredPhone: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const self = this;
      const im = new InputMask({
        mask: this.mask,
        showMaskOnFocus: this.showMaskOnFocus,
        showMaskOnHover: this.showMaskOnHover,
        onBeforePaste: (pastedValue) => {
          this.onEnteredPhone = pastedValue;
          if ((this.dynamicMask && pastedValue.length >= 11 && pastedValue.toString().substr(0, 1) === '8')
            || (this.dynamicMask && pastedValue.length >= 11 && pastedValue.toString().substr(0, 1) === '7')
          ) {
            this.onEnteredPhone = pastedValue.toString().substr(1);
            return this.onEnteredPhone;
          }
          return pastedValue;
        },
        onBeforeMask: (initialValue) => {
          /* Данный метод позволяет нам обработать введенные данные в поле до того как подставилась маска.
           * При вставке полного номера проверим что номер соответсвует полной длине и начинается с 8,
           * отредактируем и вернем данные
           */
          if (initialValue.length >= 10 && initialValue.substr(0, 1) === '8') {
            // т.к. маска еще не подставилась, замаскируем вводимое значение сами
            self.onEnteredPhone = im.format(initialValue.toString().substr(1), { inputFormat: '+7(999)999-99-99' }).value;
            if (self.dynamicMask) {
              setTimeout(() => {
                self.onChangePhone();
              }, 1000);
            }
            // вернем отредактированное значение
            return initialValue.toString().substr(1);
          }
          return initialValue;
        },
      });
      im.mask(this.$refs.phone);
    },
    keyDown(e) {
      const symbol = e.key;

      if (this.dynamicMask && /[0-9]/.test(symbol)) {
        const inputVal = this.$refs.phone.inputmask.unmaskedvalue();
        const inputValString = inputVal.toString();
        if (inputValString.length >= 10 && inputValString.substr(0, 1) === '8') {
          this.onEnteredPhone = inputVal.toString().substr(1);
        }
        // стираем + именно в начале ввода, так как при полном заполнении маски + подставится сам,
        // но если этого не сделать то + будет считаться как символ цифры и вызовет ошибку
        if (inputValString.length === 1 && inputValString.substr(0, 2) === '+') {
          this.onEnteredPhone = inputVal.toString().substr(2);
        }

        if (inputValString.length >= 11 && inputValString.substr(0, 2) === '7') {
          this.onEnteredPhone = inputValString.substr(2);
        }
      }
    },
    onChangePhone() {
      this.$emit('change-phone', {
        valuePhone: this.onEnteredPhone,
        unmasked: this.$refs.phone.inputmask.unmaskedvalue(),
      });
    },
    onBlurPhone() {
      this.$emit('blur-phone', {
        valuePhone: this.onEnteredPhone,
        unmasked: this.$refs.phone.inputmask.unmaskedvalue(),
      });
    },
    keyup(e) {
      if (e.keyCode == 13) {
        this.keyupEnter();
      } else {
        this.onChangePhone();
      }
    },
    keyupEnter() {
      this.$emit('keyup-enter');
    },
  },
  watch: {
    mask: {
      handler() {
        this.init();
      },
      deep: true,
    },
    onEnteredPhone: {
      handler(newVal) {
        /*
        * Данная конструкция является решением для фикса бага повторной вставки одного и того же номера телефона.
        * Не происходит обновление в inputMask при вводе одного и того же номера несколько раз.
        * См. BOXBERRY-320
        */
        const self = this;
        if (!newVal.length) {
          $(this.$refs.phone).blur();
          setTimeout(() => {
            $(self.$refs.phone).focus();
          }, 100);
        }
      },
      deep: true,
    },
  },
};
</script>
